<div class="row">
    <div class="col-12 col-sm-6">
        <mat-card-title class="matCard-Font">Lista de categorias</mat-card-title>
    </div>
</div>

<table style="width: 100%;" mat-table [dataSource]="dataSource" class="mat-elevation-2">

    <!-- Nome -->
    <ng-container class="w-40" matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef> Nome </th>
        <td mat-cell *matCellDef="let element"> {{ element.Nome }} </td>
    </ng-container>

    <!-- NCM -->
    <ng-container class="w-10" matColumnDef="ncm">
        <th mat-header-cell *matHeaderCellDef> NCM </th>
        <td mat-cell *matCellDef="let element"> {{ element.Ncm }} </td>
    </ng-container>

    <!-- CEST -->
    <ng-container class="w-10" matColumnDef="cest">
        <th mat-header-cell *matHeaderCellDef> CEST </th>
        <td mat-cell *matCellDef="let element"> {{ element.Cest }} </td>
    </ng-container>

    <!-- Natureza Receita -->
    <ng-container class="w-10" matColumnDef="naturezaReceita">
        <th mat-header-cell *matHeaderCellDef> Natureza da Receita </th>
        <td mat-cell *matCellDef="let element"> {{ element.NaturezaReceita }} </td>
    </ng-container>
    <ng-container matColumnDef="button">
        <th mat-header-cell *matHeaderCellDef>
            <div class="d-flex justify-content-end">

                <button *ngIf="anexo.Nome != null" mat-raised-button color="Sugestao" (click)="AdicionarCategoria()">Adicionar
                    Categoria</button>
            </div>
        </th>
        <td mat-cell *matCellDef="let element">
            <div class="d-flex justify-content-end">
                <button mat-raised-button color="warn" (click)="excluirCategoria(element)">Excluir</button>
            </div>
        </td>
    </ng-container>

    <!-- Header + Rows -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

</table>
<mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20, 100]" showFirstLastButtons>
</mat-paginator>